import { createRoutine } from "../utils/routine.utils";
export var createDocumentPackage = createRoutine("DOCUMENT_PACKAGE_CREATE");
export var revokeDocumentPackage = createRoutine("DOCUMENT_PACKAGE_REVOKE");
export var getDocumentPackage = createRoutine("DOCUMENT_PACKAGE_GET");
export var getDocumentPackages = createRoutine("DOCUMENT_PACKAGES_GET");
export var getDocumentPackagesPaged = createRoutine("DOCUMENT_PACKAGES_GET_PAGES");
export var remindDocumentPackageSigner = createRoutine("DOCUMENT_PACKAGE_REMIND_SIGNER");
